import { render, staticRenderFns } from "./NewQuantityBox.vue?vue&type=template&id=35c93c41"
import script from "./NewQuantityBox.vue?vue&type=script&lang=js"
export * from "./NewQuantityBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports